exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-vue-wrapper[data-v-520b2e08]{position:fixed;z-index:1050;outline:0}.modal-vue-container[data-v-520b2e08]{position:fixed;z-index:9998;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);transition:opacity .3s ease}", ""]);

// exports
